import { Pagination } from "@mui/material";
import React from "react";
import ShowPaginateText from "./components/show_paginate_text";
import styles from "./pagination.module.scss";

export const PaginationComponent = ({
  paginate,
  paginationHandler,
  ...props
}) => {
  if (paginate) {
    return (
      <div className={styles.pagination_wrapper}>
        <ShowPaginateText paginate={paginate} />
        {paginate && paginate.total > 0 && paginate.currentPage > 0 && (
          <Pagination
            className="custom_pagination"
            count={Math.ceil(paginate.total / paginate.limit)}
            page={parseInt(paginate.currentPage)}
            shape="rounded"
            onChange={paginationHandler}
          />
        )}
      </div>
    );
  }
  return <></>;
};

export default PaginationComponent;
